import DescriptionChoice from '../sections/channelChoice/descriptionChoice';
import ChoiceContainer from '../sections/channelChoice/choiceContainer';
import ChannelsChoiceContainer from '@components/atoms/container/channelsChoiceContainer';
import useTransform from '@shared/components/utils/hooks/useTransform';
import Direction from '@shared/types/enums/direction';
import { focusSelector, setFocus } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';
import Focus from '@shared/types/enums/focus';
import { useEffect } from 'react';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { useDispatch } from 'react-redux';
import Storage from '../../../shared/utils/storage';
import ChannelView from '@shared/types/enums/channelView';
import goToChannelMain from '@shared/actions/channels/goToChannelMain';
import goToClassicChannel from '@shared/actions/channels/goToClassicChannel';

const OFFSET = -155;

export const TChannelsChoice = () => {
  const dispatch = useDispatch();

  const { focus } = useAppSelector(focusSelector);

  const [style, setStyle, resetStyle] = useTransform(
    0,
    OFFSET,
    Direction.HORIZONTAL
  );

  useEffect(() => {
    if (focus === Focus.MENU) {
      setStyle(1);
    } else if (focus === Focus.CHANNELS_CHOICE) {
      resetStyle();
    }
  }, [focus]);

  useKeyboard({
    canBeFocused: false,
    keyDownHandler: (key) => {
      switch (key) {
        case 'RIGHT':
        case 'SELECT':
          dispatch(setFocus(Focus.CHANNELS_CHOICE));
          break;
      }
    },
  });

  const selectView = (index: number) => {
    Storage.set('userChannelViewSelection', `${index}`);
    if (index === ChannelView.Classic) {
      goToClassicChannel();
    } else {
      goToChannelMain();
    }
  };

  return (
    <ChannelsChoiceContainer style={style} animation={'slider-scroll'}>
      <DescriptionChoice></DescriptionChoice>
      <ChoiceContainer onSelectEnter={selectView}></ChoiceContainer>
    </ChannelsChoiceContainer>
  );
};
